import React, { useEffect, useState } from "react";
import { Colors, Direction } from "../../_app/types";
import { Stack, Typography } from "@mui/material";
import IconComponent from "./IconComponent";
import { capitalizeFirstLetter } from "../../utils/_capitalizeFirstLetter";
import Box from "@mui/material/Box";

interface Props {
  gridDirection: Direction;
}

const BadgeDirection = ({ gridDirection }: Props) => {
  const [color, setColor] = useState<string>(capitalizeFirstLetter(gridDirection));

  useEffect(() => {
    capitalizeFirstLetter(gridDirection) === "Central" && setColor("textSecondary");
    capitalizeFirstLetter(gridDirection) === "Long" && setColor(Colors.Success);
    capitalizeFirstLetter(gridDirection) === "Short" && setColor(Colors.Destructive);
  }, [gridDirection]);

  const BadgeDirectionStyles = {
    fontSize: "14px",
    textAlign: "right",
    whiteSpace: "nowrap",
    width: "100%",
    maxWidth: "fit-content",
  };

  const BoxBadgeDirectionStyles = { position: "relative", top: 4 };

  return (
    <Stack direction={"row"} alignItems={"center"} spacing={1}>
      <Typography sx={BadgeDirectionStyles} variant={"body2"} color={color}>
        {capitalizeFirstLetter(gridDirection)}
      </Typography>
      {capitalizeFirstLetter(gridDirection) === "Long" && (
        <IconComponent iconName={"TradeUp"} hasFill />
      )}
      {capitalizeFirstLetter(gridDirection) === "Short" && (
        <IconComponent iconName={"TradeDown"} hasFill />
      )}
      <Box sx={BoxBadgeDirectionStyles}>
        {capitalizeFirstLetter(gridDirection) === "Central" && (
          <IconComponent iconName={"TradeCenter"} hasStroke hasFill />
        )}
      </Box>
    </Stack>
  );
};

export default BadgeDirection;
